import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BootstrapErrorComponent } from './bootstrap-error.component';
import { ErrorService } from '@trustedshops/tswp-carrier-core';
import { WindowWithBootstrapError } from './bootstrap-error-handler';
import { BootstrapErrorLogoutService } from './bootstrap-error-logout.service';

@NgModule({
  declarations: [BootstrapErrorComponent],
  imports: [BrowserModule],
  providers: [
    {
      provide: ErrorService,
      useFactory: () => {
        const errorService = new ErrorService();
        // Get the bootstrap error from global storage and activate it
        const bootstrapError = (window as WindowWithBootstrapError)
          .__bootstrapError;
        if (bootstrapError) {
          errorService.activateErrorState(bootstrapError);
        }
        return errorService;
      },
    },
    BootstrapErrorLogoutService,
  ],
  bootstrap: [BootstrapErrorComponent],
})
export class BootstrapErrorModule {}
